import { FC } from 'react'

import { Avatar, AvatarFallback, AvatarImage } from '@forto-dev/phoenix-ui-core'

import { getInitialsForName } from '@/utils/initials'

import { FeedItem } from '../domain/feed'

export const ActivityFeedActorAvatar: FC<Pick<FeedItem['activity'], 'actor'>> = ({ actor }) => (
  <Avatar size="sm">
    {actor.avatar ? (
      <AvatarImage alt={actor.fullName} src={actor.avatar} />
    ) : (
      <AvatarFallback>{getInitialsForName(actor?.fullName ?? '?')}</AvatarFallback>
    )}
  </Avatar>
)
